module.exports = __webpack_public_path__ + "img/CZ27444376.c8409c90.png";